export default __webpack_public_path__ + "static/media/title_arena.6d22f326.png";